module.exports = __webpack_public_path__ + "img/developing.ca51e131.png";